import { Controller } from "@hotwired/stimulus";
import Fuse from "fuse.js";

export default class extends Controller {
  static targets = ["input", "item", "noResults", "tabList", "clearButton"];

  connect() {
    this.buildIndex();
  }

  buildIndex() {
    this.searchData = this.itemTargets.map((el, index) => ({
      index,
      question: el.dataset.faqSearchQuestion || "",
      answer: el.dataset.faqSearchAnswer || "",
      category: el.dataset.faqSearchCategory || "",
    }));

    this.fuse = new Fuse(this.searchData, {
      keys: [
        { name: "question", weight: 2 },
        { name: "answer", weight: 1 },
      ],
      threshold: 0.4,
      distance: 200,
      minMatchCharLength: 2,
    });
  }

  search() {
    const query = this.inputTarget.value.trim();

    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.toggle("hidden", query.length === 0);
    }

    if (query.length === 0) {
      this.resetDisplay();
      return;
    }

    this.activateSearchMode();

    const results = this.fuse.search(query);
    const matchedIndices = new Set(results.map((r) => r.item.index));

    this.itemTargets.forEach((el, index) => {
      el.classList.toggle("hidden", !matchedIndices.has(index));
    });

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", results.length > 0);
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.clear();
    }
  }

  clear() {
    this.inputTarget.value = "";
    if (this.hasClearButtonTarget) {
      this.clearButtonTarget.classList.add("hidden");
    }
    this.resetDisplay();
    this.inputTarget.focus();
  }

  activateSearchMode() {
    if (this.hasTabListTarget) {
      this.tabListTarget.classList.add("hidden");
    }

    // Show "tous/all" tab content, hide others
    const tabsController = this.element.querySelector(
      '[data-controller*="tabs-faqs"]'
    );
    if (tabsController) {
      const contents = tabsController.querySelectorAll(
        "[data-tabs-faqs-target='content']"
      );
      contents.forEach((content) => {
        const tabName = content.dataset.tabContent;
        if (tabName === "tous" || tabName === "all") {
          content.classList.remove("hidden");
        } else {
          content.classList.add("hidden");
        }
      });
    }
  }

  resetDisplay() {
    // Show all items
    this.itemTargets.forEach((el) => {
      el.classList.remove("hidden");
    });

    // Hide no results message
    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.add("hidden");
    }

    // Restore tab list
    if (this.hasTabListTarget) {
      this.tabListTarget.classList.remove("hidden");
    }

    // Let the tabs controller restore its active tab content
    const tabsController = this.element.querySelector(
      '[data-controller*="tabs-faqs"]'
    );
    if (tabsController) {
      const stimulusApp = this.application;
      const tabsCtrl = stimulusApp.getControllerForElementAndIdentifier(
        tabsController,
        "tabs-faqs"
      );
      if (tabsCtrl) {
        tabsCtrl.showTab(tabsCtrl.activeTabValue, false);
      }
    }
  }
}
